import React, { Component } from "react";
import "./App.css";
import fire from "./config/Fire";
import Home from "./Paginas/Eventos";
import vip from "./Paginas/vip";
import fotos from "./Paginas/fotos";
import registro from "./Paginas/registro";
import Login from "./Login";
import Aviso from "./Paginas/aviso";
import { BrowserRouter, Route, Switch } from "react-router-dom";

class App extends Component {
  constructor() {
    super();
    this.state = {
      user: null
    };
    this.authListener = this.authListener.bind(this);
  }

  componentDidMount() {
    this.authListener();
  }

  authListener() {
    fire.auth().onAuthStateChanged(user => {
      if (user) {
        this.setState({ user });
        //localStorage.setItem('user', user.uid);
      } else {
        this.setState({ user: null });
        //localStorage.removeItem('user');
      }
    });
  }
  //En el render verifica si esta autenticado o no el usuario
  render() {
    return (
      <BrowserRouter>
        <div>
          {this.state.user ? (
            <Switch>
              <Route path="/" component={Home} exact />
              <Route path="/eventos" component={Home} />
              <Route path="/vip" component={vip} />
              <Route path="/fotos" component={fotos} />
              <Route path="/registro" component={registro} />
            </Switch>
          ) : (
            <div>
              <Route path="/" component={Login} exact />
              <Route path="/aviso-de-privacidad" component={Aviso} exact />
            </div>
          )}
        </div>
      </BrowserRouter>
    );
  }
}

export default App;
